export var useShowUploadRemoveIcon = function (params) {
    var file = params.file;
    if (typeof params.showRemove === 'function') {
        return params.showRemove(file);
    }
    return params.showRemove || false;
};
